import React from 'react';
import { Star } from 'lucide-react';

interface SatisfactionRatingProps {
  rating: number;
  onChange?: (rating: number) => void;
  readonly?: boolean;
  size?: 'sm' | 'md';
}

export const SatisfactionRating: React.FC<SatisfactionRatingProps> = ({
  rating,
  onChange,
  readonly = false,
  size = 'md',
}) => {
  const starSize = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map(star => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => onChange?.(star)}
          className={`${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'} transition-transform`}
        >
          <Star
            className={`${starSize} ${
              star <= rating
                ? 'text-amber-400 fill-amber-400'
                : 'text-slate-600'
            }`}
          />
        </button>
      ))}
      <span className="ml-2 text-xs text-slate-400">({rating}/5)</span>
    </div>
  );
};
